import LocalStorageService from '../../../services/local-storage-service';
import { SET_DEAL_SCHEDULE_ZOOM } from '../../../constants/system/actions';

const dealScheduleTasksReducer: Reducer = (
  state: ReducerState = {
    zoom: LocalStorageService.hasDealScheduleZoom() ? LocalStorageService.getDealScheduleZoom() : null,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case SET_DEAL_SCHEDULE_ZOOM:
      LocalStorageService.setDealScheduleZoom(action.payload);

      return {
        ...state,
        zoom: action.payload,
      };
    default:
      return state;
  }
};

export default dealScheduleTasksReducer;
